import React, { useEffect } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { useStateRouterContext } from '@uhg-abyss/web/ui/StateRouter';
import { TrainingSupport } from '../../TopNav';
import { defaultEmptyFunction } from '../config';

const StyledHeading = styled(Heading, {
  '&.abyss-heading-root': {
    marginTop: '16px',
    padding: '8px 16px',
    fontWeight: 'bold',
    fontSize: '18px',
    color: '$gray8 !important',
  },
});

export const TrainingAndSupportContent = () => {
  const { methods } = useStateRouterContext() || {
    methods: { goBack: defaultEmptyFunction },
  };

  useEffect(() => {
    return () => {
      methods.goBack();
    };
  }, []);

  return (
    <React.Fragment>
      <StyledHeading offset={4}>Training & Support</StyledHeading>
      <TrainingSupport />
    </React.Fragment>
  );
};
